import React, { useState } from 'react';
import { ReactComponent as StarFilled } from '@repo/common/assets/icons/16px/icon_16px_star_filled.svg';
import { ReactComponent as StarOutline } from '@repo/common/assets/icons/16px/icon_16px_star_outline.svg';

const SIZES = {
  s: 'size-4',
  m: 'size-5',
  l: 'size-7',
};

/**
 * 별점 표시 · 입력.
 *
 * <p>{@code onChange} 를 주면 고를 수 있고, 없으면 읽기 전용이다.
 * 읽기 전용일 때는 반 칸을 표현하지 않고 반올림해서 보여준다 — 목록에서 숫자를 함께 띄우기 때문이다.
 *
 * @param {number} value 1~5
 * @param {function} [onChange]
 * @param {'s'|'m'|'l'} [size]
 */
const StarRating = ({ value = 0, onChange, size = 'm', className = '' }) => {
  const [hovered, setHovered] = useState(0);
  const editable = typeof onChange === 'function';
  const shown = editable ? hovered || value : Math.round(value);
  const iconClass = `${SIZES[size] ?? SIZES.m} text-icon-warning`;

  return (
    <div
      className={`flex items-center gap-0.5 ${className}`}
      role={editable ? 'radiogroup' : 'img'}
      aria-label={editable ? 'Rating' : `Rating ${value} out of 5`}
    >
      {[1, 2, 3, 4, 5].map((score) => {
        const Icon = score <= shown ? StarFilled : StarOutline;

        if (!editable) return <Icon key={score} className={iconClass} />;

        return (
          <button
            key={score}
            type='button'
            role='radio'
            aria-checked={value === score}
            aria-label={`${score} star${score > 1 ? 's' : ''}`}
            onClick={() => onChange(score)}
            onMouseEnter={() => setHovered(score)}
            onMouseLeave={() => setHovered(0)}
            className='transition-transform hover:scale-110'
          >
            <Icon className={iconClass} />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
